import HomePage from "../screens/HomePage";
import ShopPage from "../screens/ShopPage";
import StorePage from "../screens/StorePage/store";
import { HelpPage } from "../screens/HelpPage/";
import CommunityPage from "../screens/CommunityPage/community";
import ChoosenProduct from "../screens/ShopPage/oneJewellry";
import SignUp from "../screens/SignUpPage";
import LoginPage from "../screens/LoginPage";
import VisitMyPage from "../screens/MemberPage/visitMyPage";
import { NavbarObj } from "../types/other";
import VisitOtherPage from '../screens/MemberPage/visitOtherPage';
import OrdersPage from "../screens/OrdersPage";
import Basket from "../components/header/basket";
// import OrdersPage from "../screens/OrdersPage";


export const navbar: NavbarObj[] = [
  {
    element: <HomePage />,
    title: "Home",
    path: "/",
    private: false,
    hidden: false,
  },
  {
    element: <ShopPage />,
    title: "Shop",
    path: "/shop",
    private: false,
    hidden: false,
  },
    {
    element: <StorePage />,
    title: "Store",
    path: "/store",
    private: false,
    hidden: false,
  },

    {
    element: <CommunityPage />,
    title: "community",
    path: "/community",
    private: false,
    hidden: false,
  },

    {
    element: <HelpPage />,
    title: "CS",
    path: "/help",
    private: false,
    hidden: false,
  },
  {
    element: <ChoosenProduct />,
    title: "OneJewellry",
    path: "/shop/:product_id",
    private: false,
    hidden: true,
  },
 
  {
    element: <SignUp />,
    title: "sign-up",
    path: "/sign-up",
    private: false,
    hidden: true,
  },
  {
    element: <LoginPage />,
    title: "log-in",
    path: "/login",
    private: false,
    hidden: true,
  },
  {
    element: <VisitMyPage />,
    title: "my-account",
    path: "/member-page",
    private: false,
    hidden: true,
  },
   {
    element: <VisitOtherPage />,
    title: "other-account",
    path: "/member-page/:other_id",
    private: false,
    hidden: true,
  },
  {
    element: <Basket />,
    title: "basket",
    path: "/cart",
    private: false,
    hidden: true,
  },
    {
    element: <OrdersPage />,
    title: "chechout",
    path: "/checkout/:order_id",
    private: false,
    hidden: true,
  },
];